import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
//
import { copyToClipboard } from 'utils/helpers';

export class CopyToClipBoard extends React.Component {
  state = {
    copied: false,
  };

  toggleTooltip = (val) => {
    this.setState({ copied: val });
  };

  copy = () => {
    const { elementId, delay } = this.props;
    if (this.tio) {
      clearTimeout(this.tio);
      this.toggleTooltip(false);
    }

    copyToClipboard(elementId, (success) => {
      if (!success) return;
      this.toggleTooltip(true);
      this.tio = setTimeout(() => this.toggleTooltip(false), delay);
    });
  };

  render() {
    const { children } = this.props;
    const { copied } = this.state;
    return (
      <Tooltip visible={copied} title="Copied!">
        <span onClick={this.copy}>{children}</span>
      </Tooltip>
    );
  }
}

CopyToClipBoard.propTypes = {
  delay: PropTypes.number,
  elementId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

CopyToClipBoard.defaultProps = {
  delay: 1000,
};
